import { Component } from 'react';
import DataTable from '../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../helpers/table';
import { COLUMNS } from './keys';
import AdditionalBox from './additionalBox';
import { withTranslation } from 'react-i18next';

class CustomersList extends Component {
    constructor() {
        super();
        this.users = window.users ?? [];
        console.log('this.users', this.users);
        this.onSelect = this.onSelect.bind(this);
        this.getEmails = this.getEmails.bind(this);
        this.onRemoveAllSelected = this.onRemoveAllSelected.bind(this);
        this.state = {
            selectedItems: [],
            removeAllSelected: 0,
        };
    }

    searchFunction(data, search) {
        if (!search) return data;

        return data.filter((item) => {
            const decoded = item?.domains.replace(/&quot;/g, '"');
            const domains = decoded ? JSON.parse(String(decoded)) : [];
            const exists = domains.some((item) => item?.url?.includes(search));
            return (
                `${item.first_name} ${item.last_name}`
                    ?.toLowerCase()
                    ?.includes(search.toLowerCase()) ||
                `${item.username} ${item.last_name}`
                    ?.toLowerCase()
                    ?.includes(search.toLowerCase()) ||
                exists ||
                item.email?.toLowerCase()?.includes(search.toLowerCase())
            );
        });
    }

    onSelect(action, state) {
        if (action.type === 'REMOVE_ALL') return this.setState({ selectedItems: [] });
        this.setState({
            selectedItems: state.ids,
        });
    }

    getEmails() {
        const selectedEmails = this.users
            .filter((item) => this.state.selectedItems.includes(item.id))
            .map((item) => item.email);
        return selectedEmails;
    }

    onRemoveAllSelected() {
        this.setState({
            removeAllSelected: this.state.removeAllSelected + 1,
        });
    }

    render() {
        const { t } = this.props;

        const additionalBox = () => (
            <AdditionalBox
                getEmails={this.getEmails}
                onRemoveAllSelected={this.onRemoveAllSelected}
                t={t}
            />
        );

        return (
            <div className="card table-main">
                <DataTable
                    nodes={this.users}
                    sortFns={getSortKeys(COLUMNS(t))}
                    additionalBox={additionalBox}
                    COLUMNS={COLUMNS(t)}
                    fileName="Users"
                    header="Users"
                    uniqKey={'id'}
                    searchFunction={this.searchFunction}
                    additionalStyles={setAdditionalStyles(COLUMNS(t), true)}
                    hasSelect
                    onSelect={this.onSelect}
                    removeAllSelected={this.state.removeAllSelected}
                />
            </div>
        );
    }
}

export default withTranslation()(CustomersList);
